import { cn } from "@/lib/utils";
import { SVGProps } from "react";

export function Logo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="319"
      height="307"
      viewBox="0 0 319 307"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="156.681" cy="156.681" r="150.47" fill="black" />
      <circle cx="156.681" cy="156.681" r="137.604" fill="#BDC9D4" />
      <circle cx="156.681" cy="156.681" r="137.604" fill="#BDC9D4" />
      <circle cx="156.681" cy="156.681" r="137.604" fill="#BDC9D4" />
      <ellipse
        cx="154.144"
        cy="146.451"
        rx="137.604"
        ry="127.064"
        transform="rotate(-13.9283 154.144 146.451)"
        fill="#FBF9F3"
      />
      <ellipse
        cx="249.415"
        cy="178.426"
        rx="21.9552"
        ry="17.3404"
        transform="rotate(-20.1103 249.415 178.426)"
        fill="#F8D9D5"
      />
      <ellipse
        cx="127.115"
        cy="54.5233"
        rx="11.2722"
        ry="8.43019"
        transform="rotate(-33.6027 127.115 54.5233)"
        fill="#DDDEDB"
      />
      <ellipse
        cx="65.2888"
        cy="86.3099"
        rx="7.97098"
        ry="5.03431"
        transform="rotate(-33.9711 65.2888 86.3099)"
        fill="#DDDEDB"
      />
      <ellipse
        cx="234.727"
        cy="84.8141"
        rx="11.0475"
        ry="7.13193"
        transform="rotate(33.319 234.727 84.8141)"
        fill="#DDDEDB"
      />
      <ellipse
        cx="102.183"
        cy="233.409"
        rx="24.8918"
        ry="18.4591"
        transform="rotate(26.528 102.183 233.409)"
        fill="#DDDEDB"
      />
      <ellipse
        cx="61.1564"
        cy="178.297"
        rx="22.6226"
        ry="17.9673"
        transform="rotate(33.5639 61.1564 178.297)"
        fill="#F8D9D5"
      />
      <path
        d="M97.7379 153.674C97.7379 143.396 90.8157 137.663 81.726 137.663C73.6152 137.663 64.8052 146.473 64.8052 153.674C64.8052 160.597 66.9028 162.275 70.8184 162.275H89.3579C91.8052 162.275 97.7379 160.397 97.7379 153.674Z"
        fill="black"
      />
      <path
        d="M215.845 153.674C215.845 143.396 222.767 137.663 231.857 137.663C239.967 137.663 248.777 146.473 248.777 153.674C248.777 160.597 246.68 162.275 242.764 162.275H224.225C221.777 162.275 215.845 160.397 215.845 153.674Z"
        fill="black"
      />
      <path
        d="M171.784 165.91C171.784 172.623 165.771 180.594 155.422 180.594C144.515 180.594 138.781 170.945 138.781 165.91C138.781 160.876 136.264 160.387 133.887 160.387C131.882 159.851 128.573 160.932 129.132 169.546C129.831 180.314 141.438 191.362 157.8 191.362C175.979 191.362 182.692 172.343 182.692 165.91C182.692 162.274 179.755 160.387 177.308 160.387C174.86 160.387 171.784 161.715 171.784 165.91Z"
        fill="black"
      />
    </svg>
  );
}

export function Fal() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="fill-foreground"
      width={50}
      viewBox="0 0 120 48"
    >
      <path d="M120 6.463v35.2c0 5.585-.063 5.836-.752 5.836h-8.524c-.69 0-.815-.251-.815-5.836v-35.2c0-5.584.125-5.835.815-5.835h8.524c.689 0 .752.251.752 5.835ZM96.1 27.043v-1.317c0-3.138-1.442-4.393-3.95-4.393-2.444 0-3.76 1.318-4.136 3.64-.125.69-.063 1.254-.439 1.254h-8.461c-.502 0-.502-.125-.502-.564 0-3.326 3.134-10.228 14.04-10.228 7.71 0 13.226 3.075 13.226 11.608v12.55c0 2.885 1.567 6.964 1.567 7.528 0 .251-.188.377-.377.377h-9.401c-.44 0-.502-.251-.815-1.82l-.25-1.192c-.189-.941-.314-1.255-.69-1.255-.502 0-.815 1.13-2.194 2.447C92.214 47.058 90.396 48 87.262 48c-5.077 0-9.653-2.886-9.653-9.16 0-7.028 5.454-10.04 13.54-10.354 4.199-.188 4.95.251 4.95-1.443Zm0 9.098v-1.255c0-1.255-.314-1.631-1.38-1.568l-2.318.125c-2.946.188-4.701 1.694-4.701 4.518 0 2.76 1.504 4.14 3.698 4.14 2.444 0 4.7-2.258 4.7-5.96ZM60.55 23.655c0-1.192-.5-1.318-2.82-1.318h-1.128c-.439 0-.501-.314-.501-2.886v-.44c0-2.572.062-2.823.501-2.823h1.316c2.32 0 2.633-.188 2.633-1.317v-3.89C60.55 3.638 64.249 0 71.394 0c2.82 0 4.764.44 5.077.627.126.126.126.314.126 2.636v.815c0 2.385 0 2.95-.188 2.95s-1.066-.565-2.57-.565c-2.006 0-3.26 1.004-3.26 4.517v3.89c0 1.13.44 1.318 3.26 1.318h2.82c.564 0 .564.251.564 2.824v.439c0 2.572-.062 2.886-.501 2.886h-2.883c-2.82 0-3.26.126-3.26 1.318v18.008c0 5.584-.188 5.835-.689 5.835h-8.712c-.502 0-.627-.251-.627-5.835V23.655Z" />
      <path
        fillRule="evenodd"
        d="M30.157.74c.81 0 1.46.66 1.537 1.466.691 7.193 6.416 12.917 13.61 13.608.806.078 1.465.727 1.465 1.537v13.545c0 .81-.659 1.46-1.465 1.537-7.194.69-12.919 6.415-13.61 13.608-.077.807-.726 1.466-1.537 1.466H16.612c-.81 0-1.46-.66-1.537-1.466-.691-7.193-6.416-12.917-13.61-13.608C.66 32.355 0 31.706 0 30.896V17.35c0-.81.659-1.46 1.465-1.537 7.194-.69 12.919-6.415 13.61-13.608.077-.807.727-1.466 1.537-1.466h13.545ZM9.39 24.084c0 7.781 6.301 14.089 14.074 14.089s14.075-6.308 14.075-14.09c0-7.78-6.302-14.088-14.075-14.088-7.772 0-14.074 6.308-14.074 14.089Z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export function Glif() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={36}
      viewBox="0 0 83 48"
      className="fill-foreground"
    >
      <g clipPath="url(#clip0_628_60718)">
        <path d="M40.2117 0.333282H32.4263V48H40.2117V0.333282Z" />
        <path d="M52.3882 17.4391H44.6028V48H52.3882V17.4391Z" />
        <path d="M76.6119 22.8368L70.8013 17.052L64.9906 22.8368L70.8013 28.6215L76.6119 22.8368Z" />
        <path d="M54.3402 5.78397L48.5295 -0.000762939L42.7189 5.78397L48.5295 11.5687L54.3402 5.78397Z" />
        <path d="M28.0275 0.333282H20.2421V4.94882C18.3658 4.01873 16.2521 3.49169 14.0138 3.49169C6.28673 3.48781 0 9.74649 0 17.439C0 20.799 1.19896 23.8876 3.19592 26.2981H0V34.0488H7.78543V29.9332C9.66171 30.8632 11.7755 31.3903 14.0138 31.3903C21.7408 31.3903 28.0275 25.1316 28.0275 17.439C28.0275 13.8427 26.6534 10.5603 24.3995 8.08397H28.0275V0.333282ZM14.0138 23.6396C10.5804 23.6396 7.78543 20.8571 7.78543 17.439C7.78543 14.021 10.5804 11.2385 14.0138 11.2385C17.4471 11.2385 20.2421 14.021 20.2421 17.439C20.2421 20.8571 17.4471 23.6396 14.0138 23.6396Z" />
        <path d="M14.0137 34.0488H7.7854V41.7995H14.0137C17.4471 41.7995 20.2421 44.582 20.2421 48H28.0275C28.0275 40.3074 21.7408 34.0488 14.0137 34.0488Z" />
        <path d="M70.8006 8.08397C73.0467 8.08397 75.2227 9.2892 76.3711 11.5098L76.6786 11.2036L82 5.90603C79.3724 2.42984 75.2305 0.333282 70.8006 0.333282C63.2021 0.333282 57.0049 6.38269 56.7985 13.897L56.7869 48H64.5723V14.2806C64.5723 10.8626 67.3673 8.08009 70.8006 8.08009V8.08397Z" />
      </g>
    </svg>
  );
}

export function Driveline() {
  return (
    <svg
      width={130}
      viewBox="0 0 236 54"
      className="fill-foreground"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M215.901 25L219.644 2.45453H235.893L235.056 7.38635H224.928L224.312 11.2613H233.603L232.767 16.1932H223.475L222.859 20.0682H232.943L232.106 25H215.901Z" />
      <path d="M216.749 2.45453L213.006 25H207.898L201.734 13.1548H201.601L199.62 25H193.499L197.242 2.45453H202.438L208.515 14.2557H208.691L210.628 2.45453H216.749Z" />
      <path d="M194.341 2.45453L190.598 25H184.478L188.221 2.45453H194.341Z" />
      <path d="M166.768 25L170.511 2.45453H176.631L173.725 20.0682H182.84L182.003 25H166.768Z" />
      <path d="M147.484 25L151.226 2.45453H167.475L166.638 7.38635H156.511L155.894 11.2613H165.185L164.349 16.1932H155.057L154.441 20.0682H164.525L163.688 25H147.484Z" />
      <path d="M132.718 2.45453L134.7 18.3508H134.876L142.142 2.45453H149.055L137.87 25H129.504L125.805 2.45453H132.718Z" />
      <path d="M123.653 2.45453L119.91 25H113.789L117.532 2.45453H123.653Z" />
      <path d="M92.7794 25L96.5223 2.45453H106.254C107.927 2.45453 109.34 2.7591 110.492 3.36824C111.644 3.97737 112.474 4.85439 112.98 5.99927C113.486 7.14416 113.608 8.51656 113.343 10.1165C113.079 11.731 112.496 13.0924 111.593 14.2006C110.698 15.3015 109.556 16.1381 108.169 16.7106C106.79 17.2757 105.241 17.5582 103.524 17.5582H97.7112L98.5038 12.8025H103.083C103.803 12.8025 104.434 12.7145 104.977 12.5383C105.52 12.3549 105.96 12.0686 106.298 11.6797C106.635 11.2834 106.856 10.7623 106.958 10.1165C107.061 9.47063 107.01 8.94589 106.804 8.54224C106.599 8.13126 106.258 7.83036 105.78 7.63954C105.303 7.44139 104.713 7.34231 104.008 7.34231H101.85L98.9002 25H92.7794ZM107.707 14.652L111.626 25H104.977L101.19 14.652H107.707Z" />
      <path d="M78.8509 25H70.0441L73.787 2.45453H82.2415C84.5606 2.45453 86.4981 2.92056 88.054 3.85261C89.6099 4.78467 90.7144 6.1167 91.3676 7.84871C92.0207 9.58071 92.1492 11.643 91.7529 14.0355C91.3712 16.3399 90.597 18.3105 89.4301 19.9471C88.2705 21.5837 86.788 22.835 84.9826 23.701C83.1846 24.567 81.1407 25 78.8509 25ZM77.0235 19.804H79.2472C80.3627 19.804 81.3572 19.6095 82.2305 19.2205C83.1112 18.8242 83.8451 18.1637 84.4322 17.239C85.0267 16.3069 85.456 15.0336 85.7202 13.419C85.9697 11.8925 85.9624 10.7146 85.6982 9.88528C85.434 9.04863 84.9313 8.46885 84.19 8.14594C83.4488 7.81568 82.491 7.65055 81.3168 7.65055H79.049L77.0235 19.804Z" />
      <path d="M222.562 46L224.977 31.4545H227.172L225.069 44.1108H231.66L231.348 46H222.562Z" />
      <path d="M202.473 46L204.888 31.4545H207.083L204.98 44.1108H211.571L211.259 46H202.473Z" />
      <path d="M180.898 46H178.568L186.218 31.4545H188.753L191.573 46H189.243L187.12 34.0966H187.006L180.898 46ZM182.233 40.304H189.79L189.478 42.1506H181.921L182.233 40.304Z" />
      <path d="M157.783 46L160.198 31.4545H165.525C166.557 31.4545 167.383 31.625 168.004 31.9659C168.629 32.3021 169.059 32.759 169.296 33.3366C169.533 33.9095 169.59 34.5559 169.467 35.2756C169.367 35.8816 169.171 36.3906 168.877 36.8025C168.588 37.2145 168.238 37.5459 167.826 37.7969C167.414 38.0478 166.981 38.2301 166.526 38.3437L166.498 38.4858C166.971 38.5095 167.414 38.6657 167.826 38.9545C168.243 39.2386 168.56 39.6434 168.778 40.169C168.996 40.6946 169.045 41.3338 168.927 42.0866C168.799 42.83 168.51 43.4976 168.06 44.0895C167.615 44.6766 167.002 45.143 166.221 45.4886C165.44 45.8295 164.486 46 163.359 46H157.783ZM160.291 44.1179H163.458C164.509 44.1179 165.295 43.9143 165.816 43.5071C166.342 43.0999 166.659 42.5909 166.768 41.9801C166.839 41.5208 166.789 41.0994 166.619 40.7159C166.453 40.3324 166.174 40.027 165.781 39.7997C165.392 39.5724 164.905 39.4588 164.318 39.4588H161.072L160.291 44.1179ZM161.363 37.7471H164.296C164.789 37.7471 165.248 37.6524 165.674 37.4631C166.105 37.2737 166.462 37.0061 166.747 36.6605C167.035 36.3149 167.215 35.91 167.286 35.446C167.39 34.8399 167.265 34.3357 166.91 33.9332C166.559 33.526 165.951 33.3224 165.085 33.3224H162.087L161.363 37.7471Z" />
      <path d="M136.933 46L139.347 31.4545H148.467L148.154 33.3437H141.229L140.491 37.7756H146.94L146.627 39.6577H140.178L139.44 44.1108H146.45L146.137 46H136.933Z" />
      <path d="M124.956 35.3608C124.961 34.6458 124.729 34.099 124.26 33.7202C123.796 33.3414 123.147 33.152 122.314 33.152C121.718 33.152 121.185 33.2467 120.716 33.4361C120.252 33.6207 119.873 33.8764 119.58 34.2031C119.291 34.5251 119.113 34.892 119.047 35.304C118.986 35.6496 119.016 35.9479 119.139 36.1989C119.267 36.4498 119.45 36.6605 119.686 36.831C119.928 36.9967 120.193 37.1364 120.482 37.25C120.771 37.3589 121.05 37.4489 121.32 37.5199L122.683 37.8892C123.124 38.0028 123.571 38.1567 124.026 38.3508C124.48 38.545 124.89 38.8007 125.254 39.1179C125.619 39.4351 125.891 39.8281 126.071 40.2969C126.251 40.7656 126.287 41.3267 126.178 41.9801C126.036 42.804 125.702 43.5355 125.176 44.1747C124.651 44.8139 123.957 45.3182 123.095 45.6875C122.234 46.0568 121.235 46.2415 120.098 46.2415C119.009 46.2415 118.093 46.0687 117.35 45.723C116.611 45.3774 116.069 44.8873 115.723 44.2528C115.378 43.6136 115.254 42.8561 115.354 41.9801H117.563C117.511 42.5057 117.605 42.9437 117.847 43.294C118.093 43.6397 118.439 43.8977 118.884 44.0682C119.329 44.2339 119.833 44.3168 120.396 44.3168C121.021 44.3168 121.592 44.2197 122.108 44.0256C122.624 43.8267 123.05 43.5521 123.387 43.2017C123.723 42.8466 123.929 42.4323 124.004 41.9588C124.08 41.5279 124.019 41.1752 123.82 40.9006C123.626 40.6259 123.332 40.3987 122.939 40.2187C122.551 40.0388 122.108 39.8802 121.611 39.7429L119.97 39.2741C118.858 38.9569 118.015 38.4905 117.442 37.875C116.869 37.2595 116.663 36.4451 116.824 35.4318C116.966 34.5937 117.316 33.8622 117.875 33.2372C118.434 32.6122 119.13 32.1269 119.963 31.7812C120.797 31.4309 121.701 31.2557 122.676 31.2557C123.661 31.2557 124.499 31.4309 125.191 31.7812C125.882 32.1316 126.393 32.6146 126.725 33.2301C127.056 33.8456 127.172 34.5559 127.073 35.3608H124.956Z" />
      <path d="M93.8035 46H91.474L99.1231 31.4545H101.659L104.478 46H102.149L100.025 34.0966H99.9115L93.8035 46ZM95.1388 40.304H102.696L102.383 42.1506H94.8263L95.1388 40.304Z" />
      <path d="M70.689 46L73.1037 31.4545H78.4304C79.4626 31.4545 80.2889 31.625 80.9091 31.9659C81.5341 32.3021 81.965 32.759 82.2017 33.3366C82.4385 33.9095 82.4953 34.5559 82.3722 35.2756C82.2728 35.8816 82.0763 36.3906 81.7827 36.8025C81.4939 37.2145 81.1435 37.5459 80.7316 37.7969C80.3196 38.0478 79.8864 38.2301 79.4319 38.3437L79.4035 38.4858C79.8769 38.5095 80.3196 38.6657 80.7316 38.9545C81.1482 39.2386 81.4655 39.6434 81.6833 40.169C81.9011 40.6946 81.9508 41.3338 81.8324 42.0866C81.7046 42.83 81.4158 43.4976 80.966 44.0895C80.5209 44.6766 79.9077 45.143 79.1265 45.4886C78.3452 45.8295 77.3911 46 76.2642 46H70.689ZM73.1961 44.1179H76.3637C77.4148 44.1179 78.2008 43.9143 78.7216 43.5071C79.2472 43.0999 79.5644 42.5909 79.6733 41.9801C79.7444 41.5208 79.6946 41.0994 79.5242 40.7159C79.3585 40.3324 79.0791 40.027 78.6861 39.7997C78.2979 39.5724 77.8102 39.4588 77.2231 39.4588H73.9773L73.1961 44.1179ZM74.2685 37.7471H77.2017C77.6942 37.7471 78.1535 37.6524 78.5796 37.4631C79.0105 37.2737 79.3679 37.0061 79.652 36.6605C79.9409 36.3149 80.1208 35.91 80.1918 35.446C80.296 34.8399 80.1705 34.3357 79.8154 33.9332C79.465 33.526 78.8566 33.3224 77.9901 33.3224H74.9929L74.2685 37.7471Z" />
      <path d="M1 2.5C5 1.83333 15.2 0.5 24 0.5C35 0.5 59 6.5 59 26.5C59 42.5 42 46.8333 33.5 47C29.4801 46.0352 20.4648 45.8151 15.5243 52.2666C15.5469 53.1073 15.4688 53.4688 15 53C15.169 52.7464 15.3439 52.5021 15.5243 52.2666C15.4745 50.4174 14.9376 46.2498 17 43.5C20 39.5 24.5 35.5 33.5 35.5C42.5 35.5 51.5 33.5 51.5 24.5C51.5 15.5 43 4 24.5 4C6 4 6 6.5 4.5 6C3.3 5.6 1.66667 3.5 1 2.5Z" />
      <path d="M1 2.5C5 1.83333 15.2 0.5 24 0.5C35 0.5 59 6.5 59 26.5C59 42.5 42 46.8333 33.5 47C29.3333 46 19.8 45.8 15 53C16.5 54.5 14 47.5 17 43.5C20 39.5 24.5 35.5 33.5 35.5C42.5 35.5 51.5 33.5 51.5 24.5C51.5 15.5 43 4 24.5 4C6 4 6 6.5 4.5 6C3.3 5.6 1.66667 3.5 1 2.5Z" />
      <path
        d="M24 6C15.6 6 8.16667 7.33333 5.5 8L8.5 10.5C9 10.1667 12.8 9.5 24 9.5C35.2 9.5 43 14.8333 45.5 17.5C45.5 13.5 34.5 6 24 6Z"
        className="stroke-fill-foreground"
      />
      <path
        d="M25.2625 12C18.3325 12 12.2 13.0435 10 13.5652L12.475 15.5217C12.8875 15.2609 16.0225 14.7391 25.2625 14.7391C34.5025 14.7391 40.9375 18.913 43 21C43 17.8696 33.925 12 25.2625 12Z"
        className="stroke-fill-foreground"
      />
      <path
        d="M26.9917 16.7012C21.1279 16.5845 15.9182 17.5242 14.0464 18.0087L16.1016 20.0061C16.4558 19.7523 19.1189 19.2836 26.9371 19.4392C34.7554 19.5949 40.1172 23.8756 41.8209 25.9964C41.8832 22.8672 34.3213 16.8471 26.9917 16.7012Z"
        className="stroke-fill-foreground"
      />
    </svg>
  );
}

export function Brilliant() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={150}
      viewBox="0 0 737.24 137.98"
    >
      <defs>
        <style>
          {
            ".cls-1{fill:none;stroke:var(--foreground);stroke-miterlimit:10;stroke-width:10px}.cls-2,.cls-3{fill:var(--foreground);stroke-width:0}.cls-3{fill:var(--foreground)}"
          }
        </style>
      </defs>
      <g transform="translate(-121.98 -214.26)">
        <g data-name="Layer 13">
          <g>
            <ellipse
              cx={190.9}
              cy={266.7}
              className="cls-1"
              rx={63.92}
              ry={47.44}
            />
            <path
              d="M249.17 290.24c3.23 4.83 5.87 11 5.87 16.58 0 5.58-1.79 10.9-5.02 15.73-3.23 4.83-7.91 9.19-13.7 12.85-5.78 3.66-12.67 6.62-20.32 8.66s-16.05 3.18-24.88 3.18c-8.83 0-17.23-1.13-24.88-3.18-7.65-2.04-14.53-5-20.32-8.66-5.79-3.66-10.46-8.01-13.7-12.85-3.24-4.84-5.02-10.15-5.02-15.73s1.79-11.74 5.02-16.58"
              className="cls-1"
            />
            <path d="M164.14 262.24h53.72v9.09h-53.72z" className="cls-2" />
            <path d="M150.83 268h13.44v9.19h-13.44z" className="cls-2" />
            <path d="M139.54 274.04h11.3v9.12h-11.3z" className="cls-2" />
            <path d="M131.53 280.7h8v7.95h-8z" className="cls-2" />
            <path d="M217.76 268.06h13.44v9.19h-13.44z" className="cls-2" />
            <path d="M231.06 274.09h11.13v9.12h-11.13z" className="cls-2" />
            <path d="M242.18 280.75h8.21v7.95h-8.21z" className="cls-2" />
          </g>
        </g>
      </g>
      <g data-name="TEXT Final" transform="translate(-121.98 -214.26)">
        <g>
          <path
            d="M295.4 261.68h27.07c4.03 0 7.58.7 10.66 2.1 3.07 1.4 5.46 3.36 7.15 5.88 1.7 2.52 2.54 5.4 2.54 8.65 0 3.82-1.2 6.96-3.6 9.41-2.4 2.45-5.75 3.9-10.03 4.35v.19c5.82.19 10.37 1.8 13.63 4.83 3.26 3.03 4.9 6.96 4.9 11.8 0 3.76-.94 7.12-2.83 10.08-1.89 2.96-4.61 5.3-8.16 7.02-3.55 1.72-7.67 2.58-12.34 2.58h-29v-66.89zm32.69 26.43c1.82-.8 3.2-1.94 4.13-3.44.93-1.5 1.39-3.23 1.39-5.21 0-2.99-1.04-5.38-3.12-7.17-2.08-1.78-5.1-2.68-9.07-2.68h-17.09v19.69h17.09c2.62 0 4.85-.4 6.67-1.19zm3.6 31.1c2.24-.96 3.92-2.31 5.04-4.06 1.12-1.75 1.68-3.84 1.68-6.26 0-3.63-1.28-6.48-3.84-8.55-2.56-2.07-6.31-3.11-11.23-3.11h-19.01v23.41h19.01c3.33 0 6.11-.48 8.35-1.43z"
            className="cls-3"
          />
          <path
            d="M358.19 276.02h8.45v9.17h.19c1.41-3.12 3.09-5.43 5.04-6.93 1.95-1.5 4.88-2.25 8.79-2.25h5.09v7.65h-6.24c-4.35 0-7.55 1.27-9.6 3.82s-3.07 6.37-3.07 11.47v29.62h-8.64v-52.56z"
            className="cls-3"
          />
          <path d="M392.75 276.02h8.64v52.56h-8.64z" className="cls-3" />
          <path d="M415.79 253.94h8.64v74.63h-8.64z" className="cls-3" />
          <path d="M438.83 253.94h8.64v74.63h-8.64z" className="cls-3" />
          <path d="M461.68 276.02h8.64v52.56h-8.64z" className="cls-3" />
          <path
            d="M509.35 326.91c-3.23 2.07-6.99 3.11-11.28 3.11-3.39 0-6.47-.64-9.22-1.91-2.75-1.27-4.91-3.17-6.48-5.69-1.57-2.52-2.35-5.53-2.35-9.03 0-5.54 1.9-9.67 5.71-12.38 3.81-2.71 8.59-4.06 14.35-4.06h8.35c2.62 0 4.61-.54 5.95-1.62 1.34-1.08 2.02-2.64 2.02-4.68 0-2.74-1.12-4.86-3.36-6.35-2.24-1.5-5.09-2.25-8.54-2.25-3.97 0-7.2.96-9.7 2.87-2.5 1.91-3.87 4.62-4.13 8.12h-8.64c.38-5.73 2.48-10.24 6.29-13.52 3.81-3.28 9.2-4.92 16.18-4.92 4.74 0 8.62.75 11.66 2.25 3.04 1.5 5.28 3.58 6.72 6.26 1.44 2.68 2.16 5.8 2.16 9.36v25.13c0 1.21.25 2.07.77 2.58.51.51 1.38.76 2.59.76h2.4v7.64h-5.66c-2.56 0-4.58-.7-6.05-2.1-1.47-1.4-2.21-3.31-2.21-5.73v-3.06h-.19c-1.67 4.08-4.11 7.15-7.35 9.22zm-1.34-6.36c2.53-1.34 4.56-3.36 6.1-6.07 1.54-2.71 2.3-6.04 2.3-9.99v-5.92h-.19c-.96 1.98-2.35 3.43-4.18 4.35-1.82.92-4.31 1.39-7.44 1.39h-4.32c-3.84 0-6.67.86-8.5 2.58-1.82 1.72-2.74 3.89-2.74 6.5s.88 4.87 2.64 6.59c1.76 1.72 4.43 2.58 8.02 2.58 3.01 0 5.78-.67 8.3-2.01z"
            className="cls-3"
          />
          <path
            d="M539.65 276.02h8.45v9.84h.19c1.6-3.57 3.9-6.34 6.91-8.31 3.01-1.97 6.53-2.96 10.56-2.96 3.71 0 6.91.86 9.6 2.58 2.69 1.72 4.74 4.27 6.14 7.64 1.41 3.38 2.11 7.45 2.11 12.23v31.54h-8.64V297.9c0-5.41-1.06-9.38-3.17-11.9-2.11-2.52-5.03-3.77-8.74-3.77-2.63 0-5.06.64-7.3 1.91-2.24 1.28-4.05 3.25-5.42 5.92-1.38 2.68-2.06 6.02-2.06 10.03v28.48h-8.64v-52.56z"
            className="cls-3"
          />
          <path
            d="M589.28 276.02h35.91v7.65h-35.91zm14.12 49.07c-2.37-2.32-3.55-5.78-3.55-10.37v-53.04h8.64v53.04c0 2.17.53 3.74 1.58 4.73 1.06.99 2.64 1.48 4.75 1.48h10.85v7.64h-11.81c-4.61 0-8.1-1.16-10.46-3.49z"
            className="cls-3"
          />
          <path
            d="M697.2 320.65v7.93h-39.65v-66.89h8.93v58.96z"
            className="cls-3"
          />
          <path
            d="M730.66 326.91c-3.23 2.07-6.99 3.11-11.28 3.11-3.39 0-6.47-.64-9.22-1.91-2.75-1.27-4.91-3.17-6.48-5.69-1.57-2.52-2.35-5.53-2.35-9.03 0-5.54 1.9-9.67 5.71-12.38 3.81-2.71 8.59-4.06 14.35-4.06h8.35c2.62 0 4.61-.54 5.95-1.62 1.34-1.08 2.02-2.64 2.02-4.68 0-2.74-1.12-4.86-3.36-6.35-2.24-1.5-5.09-2.25-8.54-2.25-3.97 0-7.2.96-9.7 2.87-2.5 1.91-3.87 4.62-4.13 8.12h-8.64c.38-5.73 2.48-10.24 6.29-13.52 3.81-3.28 9.2-4.92 16.18-4.92 4.74 0 8.62.75 11.67 2.25 3.04 1.5 5.28 3.58 6.72 6.26 1.44 2.68 2.16 5.8 2.16 9.36v25.13c0 1.21.25 2.07.77 2.58.51.51 1.38.76 2.59.76h2.4v7.64h-5.66c-2.56 0-4.58-.7-6.05-2.1-1.47-1.4-2.21-3.31-2.21-5.73v-3.06h-.19c-1.67 4.08-4.11 7.15-7.34 9.22zm-1.35-6.36c2.53-1.34 4.56-3.36 6.1-6.07 1.54-2.71 2.3-6.04 2.3-9.99v-5.92h-.19c-.96 1.98-2.35 3.43-4.18 4.35-1.82.92-4.31 1.39-7.44 1.39h-4.32c-3.84 0-6.67.86-8.5 2.58-1.82 1.72-2.74 3.89-2.74 6.5s.88 4.87 2.64 6.59c1.76 1.72 4.43 2.58 8.02 2.58 3.01 0 5.78-.67 8.31-2.01z"
            className="cls-3"
          />
          <path
            d="M776.64 326.63c-3.32-2.25-5.73-5.31-7.24-9.18h-.18c.06 1.33.09 3.24.09 5.71v5.42h-8.06v-67.32h8.15v20.41c0 2.47-.06 4.38-.18 5.71h.18c1.51-3.87 3.92-6.93 7.24-9.18 3.32-2.25 7.09-3.38 11.32-3.38s7.84 1.08 11.41 3.24c3.56 2.16 6.43 5.31 8.6 9.47 2.17 4.16 3.26 9.12 3.26 14.89 0 5.77-1.09 10.74-3.26 14.89-2.17 4.16-5.04 7.31-8.6 9.47-3.56 2.16-7.36 3.24-11.41 3.24s-8-1.13-11.32-3.38zm18.02-6.56c2.53-1.68 4.51-4.06 5.93-7.14s2.13-6.58 2.13-10.52c0-3.94-.71-7.44-2.13-10.52-1.42-3.08-3.39-5.46-5.93-7.14-2.53-1.68-5.43-2.52-8.69-2.52s-6.16.84-8.69 2.52c-2.53 1.68-4.5 4.06-5.88 7.14-1.39 3.08-2.08 6.58-2.08 10.52 0 3.94.69 7.44 2.08 10.52 1.39 3.08 3.35 5.46 5.88 7.14 2.53 1.68 5.43 2.52 8.69 2.52s6.16-.84 8.69-2.52z"
            className="cls-3"
          />
          <path
            d="M826.75 327.72c-3.2-1.53-5.7-3.71-7.49-6.55-1.79-2.83-2.78-6.16-2.98-9.99h9.03c.19 3.82 1.42 6.67 3.7 8.55 2.27 1.88 5.3 2.82 9.07 2.82 2.43 0 4.56-.38 6.38-1.15 1.82-.77 3.23-1.86 4.22-3.3.99-1.43 1.49-3.11 1.49-5.02 0-2.42-.83-4.28-2.5-5.59-1.67-1.3-4.22-1.96-7.68-1.96h-5.66c-5.31 0-9.49-1.32-12.53-3.97-3.04-2.64-4.56-6.16-4.56-10.56 0-3.12.8-5.92 2.4-8.41 1.6-2.48 3.92-4.44 6.96-5.88 3.04-1.43 6.64-2.15 10.8-2.15 4.16 0 7.97.76 11.04 2.29 3.07 1.53 5.42 3.68 7.06 6.45 1.63 2.77 2.54 6.01 2.74 9.7h-9.02c-.19-3.5-1.28-6.21-3.26-8.12-1.99-1.91-4.83-2.87-8.54-2.87-3.39 0-6.1.78-8.11 2.34-2.02 1.56-3.02 3.65-3.02 6.26 0 2.29.77 4.01 2.3 5.16 1.54 1.15 3.68 1.72 6.43 1.72h6.24c5.76 0 10.19 1.43 13.3 4.3 3.1 2.87 4.66 6.56 4.66 11.09 0 3.31-.86 6.26-2.59 8.84s-4.18 4.6-7.34 6.07c-3.17 1.46-6.9 2.2-11.19 2.2-4.29 0-8.13-.76-11.33-2.29z"
            className="cls-3"
          />
        </g>
      </g>
    </svg>
  );
}

export function VisualLayer() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={130}
      viewBox="0 0 159 32"
      className="fill-foreground"
    >
      <path d="M8.94 1.962 8.296 0H0l3.666 10.335L8.94 1.962Z" />
      <path d="M32.454 0h-8.25L20.79 10.335l9.316-3.718L32.454 0Z" />
      <path d="M11.701 10.335 8.94 1.962l-3.66 5.81 6.422 2.563Z" />
      <path d="m8.141 22.951 8.087 1.208-4.524-13.824-5.499 7.158 1.936 5.458Z" />
      <path d="m16.227 24.16 8.086-1.206 2.048-5.774-5.57-6.845-4.564 13.824Z" />
      <path d="M16.226 24.16 21.104 32h-9.755l4.877-7.84Z" />
      <path d="M16.228 24.16 11.35 32 8.14 22.95l8.088 1.209Z" />
      <path d="m21.105 32 3.208-9.046-8.086 1.205L21.105 32Z" />
      <path d="m6.205 17.494 5.498-7.159L2.34 6.598l3.865 10.896Z" />
      <path d="m26.36 17.18-5.569-6.845 9.316-3.718L26.36 17.18Z" />
      <path d="M43.504 8.948h.076c.444 0 .839.278.988.696l3.812 10.688a.21.21 0 0 0 .396 0l3.803-10.687c.15-.418.544-.697.988-.697h.075c.725 0 1.231.719.987 1.402l-4.461 12.462c-.15.416-.544.695-.987.695h-1.216c-.443 0-.839-.279-.987-.695L42.517 10.35a1.048 1.048 0 0 1 .987-1.402ZM56.6 10.955a1.283 1.283 0 0 1-.389-.942c0-.37.13-.682.389-.942.26-.26.573-.39.942-.39.37 0 .682.13.942.39.26.26.39.573.39.942 0 .37-.13.683-.39.942-.259.26-.573.39-.942.39s-.683-.13-.942-.39Zm-.143 11.504v-8.51c0-.58.47-1.05 1.048-1.05h.074c.579 0 1.048.47 1.048 1.05v8.51c0 .579-.47 1.048-1.048 1.048h-.074c-.578 0-1.048-.47-1.048-1.048ZM60.667 16.136v-.256c0-.826.298-1.529.896-2.11a2.981 2.981 0 0 1 2.155-.87h5.177c.579 0 1.049.47 1.049 1.05v.063c0 .579-.47 1.049-1.049 1.049h-5.176a.895.895 0 0 0-.63.24.759.759 0 0 0-.262.58v.255c0 .232.087.43.262.594a.887.887 0 0 0 .63.245h3.87c.84 0 1.556.292 2.15.876.593.584.89 1.289.89 2.114v.553c0 .826-.297 1.53-.89 2.114a2.956 2.956 0 0 1-2.15.875h-5.392c-.578 0-1.048-.47-1.048-1.048v-.064c0-.579.47-1.048 1.048-1.048h5.392a.887.887 0 0 0 .63-.246.786.786 0 0 0 .26-.594v-.533a.802.802 0 0 0-.26-.598.877.877 0 0 0-.63-.251h-3.87c-.84 0-1.558-.292-2.156-.876-.597-.584-.896-1.288-.896-2.114ZM72.668 19.678V13.95c0-.578.47-1.048 1.048-1.048h.064c.579 0 1.049.47 1.049 1.048v5.699c0 .477.162.884.486 1.218.324.335.718.502 1.182.502h3.548a.21.21 0 0 0 .21-.21V13.95c0-.578.47-1.048 1.048-1.048h.064c.579 0 1.048.47 1.048 1.048v7.41c0 .593-.213 1.1-.64 1.52-.426.42-.94.63-1.54.63h-3.737c-1.052 0-1.953-.376-2.703-1.127-.75-.751-1.126-1.652-1.126-2.703h-.001ZM84.454 19.678V16.71c0-1.05.374-1.948 1.121-2.692.748-.744 1.65-1.116 2.709-1.116h4.869c.579 0 1.048.47 1.048 1.048v8.51c0 .58-.47 1.05-1.048 1.05h-.064c-.579 0-1.048-.47-1.048-1.05v-7.188a.21.21 0 0 0-.21-.21h-3.548a1.61 1.61 0 0 0-1.182.487 1.61 1.61 0 0 0-.486 1.182v2.928c0 .464.163.861.491 1.193.328.33.72.497 1.178.497h1.48c.58 0 1.049.47 1.049 1.048v.064c0 .579-.47 1.048-1.049 1.048h-1.48c-1.052 0-1.953-.375-2.703-1.126-.75-.751-1.126-1.652-1.126-2.703h-.001ZM96.346 22.458V9.996c0-.579.47-1.048 1.048-1.048h.064c.579 0 1.048.47 1.048 1.048v12.462c0 .58-.47 1.049-1.048 1.049h-.064c-.579 0-1.048-.47-1.048-1.049ZM106.146 19.432V9.996c0-.578.469-1.048 1.048-1.048h.053c.579 0 1.049.47 1.049 1.048v9.436c0 .533.187.986.563 1.362.375.375.826.563 1.352.563h6.169c.579 0 1.049.47 1.049 1.049v.053a1.05 1.05 0 0 1-1.049 1.048h-6.169c-1.12 0-2.077-.397-2.872-1.193-.795-.795-1.193-1.756-1.193-2.882ZM118.649 19.679v-2.97c0-1.05.374-1.948 1.121-2.692.748-.744 1.65-1.116 2.709-1.116h4.869c.579 0 1.048.47 1.048 1.049v8.51c0 .579-.469 1.049-1.048 1.049h-.064c-.579 0-1.048-.47-1.048-1.049v-7.189a.21.21 0 0 0-.21-.21h-3.548c-.464 0-.859.163-1.182.487a1.607 1.607 0 0 0-.486 1.182v2.928c0 .464.163.862.491 1.193a1.6 1.6 0 0 0 1.178.497h1.48c.579 0 1.049.47 1.049 1.048v.064a1.05 1.05 0 0 1-1.049 1.049h-1.48c-1.052 0-1.953-.376-2.703-1.127-.751-.75-1.126-1.652-1.126-2.703h-.001ZM131.239 12.9h.046c.437 0 .828.272.982.682l2.305 6.152a.21.21 0 0 0 .393.001l2.36-6.16c.155-.406.544-.674.979-.674h.136c.736 0 1.243.739.978 1.425l-4.822 12.503c-.156.405-.545.671-.979.671h-.126c-.734 0-1.24-.734-.98-1.42l1.109-2.92-3.361-8.838a1.048 1.048 0 0 1 .979-1.421h.001ZM141.292 20.518v-5.427c0-.607.222-1.124.665-1.55.444-.427.976-.64 1.598-.64h4.422c.847 0 1.568.3 2.166.901.597.6.896 1.328.896 2.18v.297a2.94 2.94 0 0 1-.896 2.155 2.95 2.95 0 0 1-2.166.897h-2.248a1.05 1.05 0 0 1-1.049-1.049v-.053c0-.579.47-1.049 1.049-1.049h2.269a.85.85 0 0 0 .63-.266.887.887 0 0 0 .261-.645v-.286a.907.907 0 0 0-.261-.65.845.845 0 0 0-.63-.272H144.5c-.578 0-1.048.47-1.048 1.048v4.4c0 .231.079.43.235.593a.764.764 0 0 0 .573.246h4.982c.579 0 1.048.47 1.048 1.048v.064c0 .579-.469 1.048-1.048 1.048h-4.982a2.852 2.852 0 0 1-2.099-.875 2.89 2.89 0 0 1-.87-2.114l.001-.001ZM154.131 23.508c-.579 0-1.048-.47-1.048-1.049v-6.59c0-.818.298-1.518.896-2.098a2.98 2.98 0 0 1 2.155-.87h1.317c.579 0 1.048.47 1.048 1.048v.053c0 .58-.469 1.049-1.048 1.049h-1.317a.876.876 0 0 0-.63.25.814.814 0 0 0-.261.61v6.549a1.05 1.05 0 0 1-1.049 1.048h-.063Z" />
    </svg>
  );
}

export function Voxel() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={100}
      viewBox="0 0 150 42"
      fill="none"
      className="fill-foreground"
    >
      <g clipPath="url(#a)">
        <path d="M6.663.15c-.55.197-1.08.61-1.39 1.096-.523.806-.48-.478-.48 14.954L4.8 30.072l1.185.704c.65.392 1.207.711 1.228.711.028 0 .05-6.457.05-14.351 0-13.814.006-14.366.126-14.475.198-.188.325-.152 1.038.276.36.218.67.4.691.4.092-.001 2.385-1.423 2.385-1.488C11.517 1.747 8.906.23 8.504.107c-.5-.16-1.326-.137-1.841.044Z" />
        <path d="M17.211.216c-.473.124-.89.356-4.728 2.634L8.638 5.128l-.021 14.337L8.603 33.8l-1.256-.747c-.685-.406-1.842-1.103-2.569-1.538l-1.326-.79V19.493c0-6.175-.021-11.224-.043-11.224-.113 0-2.123 1.226-2.377 1.45-.396.349-.784.995-.925 1.539-.106.42-.12 1.277-.099 9.896l.022 9.432.26.544c.389.799.784 1.154 2.386 2.119 5.023 3.018 6.329 3.787 6.463 3.787.085 0 2.11-1.16 4.495-2.575l4.346-2.576.021-4.897c.021-4.637.028-4.912.155-5.224.24-.58.621-1.103 1.03-1.408.22-.167 2.082-1.291 4.15-2.51 2.06-1.22 3.746-2.25 3.753-2.293 0-.05-.049-.101-.105-.13-.113-.044-15.009-8.86-15.22-8.997-.1-.073.282-.327 2.364-1.567 1.368-.82 2.547-1.488 2.624-1.48.078 0 3.599 2.06 7.818 4.578l7.677 4.578.297-.174c.854-.5 1.884.108 1.884 1.11v.355l.691.414c.388.225.72.413.741.413.085 0 .056-2.728-.028-3.134-.12-.58-.522-1.32-.939-1.705-.395-.363-15.46-9.345-15.96-9.512C18.58.18 17.536.13 17.21.216Z" />
        <path d="M15.539 5.57c-.67.385-1.214.734-1.214.777 0 .036 5.398 3.272 11.995 7.183 7.085 4.194 12.045 7.183 12.116 7.284.155.24.07.341-.607.755l-.579.348v1.487c0 .82.021 1.473.057 1.459 1.08-.631 2.505-1.495 2.674-1.633.127-.094.353-.362.508-.595.776-1.204.628-2.895-.339-3.787-.26-.24-12.849-7.763-23.186-13.85l-.211-.131-1.214.704Z" />
        <path d="M68.868 11.897c-4.375.566-7.62 3.7-8.298 8.018-.134.841-.134 2.495 0 3.337.663 4.216 3.62 7.19 7.868 7.923.91.152 2.716.152 3.598-.007.367-.066.946-.196 1.278-.298 3.048-.892 5.454-3.25 6.364-6.247.353-1.153.423-1.74.381-3.366-.028-1.299-.056-1.575-.212-2.177-.966-3.678-3.655-6.225-7.423-7.037-.818-.175-2.716-.254-3.556-.146Zm2.879 3.12c2.23.559 3.973 2.293 4.587 4.571.606 2.235.14 4.687-1.207 6.407-1.792 2.292-4.855 3.047-7.55 1.864-1.905-.834-3.31-2.612-3.768-4.752-.176-.863-.17-2.35.028-3.17.663-2.78 2.604-4.615 5.363-5.065.593-.094 1.87-.022 2.547.145ZM43.551 12.151c-.141.102-.162.182-.162.566 0 .421.211.994 3.351 9.185 1.983 5.174 3.408 8.801 3.5 8.903.155.174.17.174 1.757.174 1.588 0 1.602 0 1.743-.16.078-.094.176-.232.219-.312.035-.08 1.552-4.07 3.358-8.866 2.032-5.383 3.288-8.815 3.288-8.967 0-.472-.091-.501-1.65-.472-1.299.022-1.39.03-1.532.174-.099.102-1.002 2.62-2.604 7.227-1.347 3.888-2.497 7.139-2.547 7.226-.113.181-.29.21-.402.065-.042-.05-1.228-3.323-2.625-7.277-1.884-5.31-2.59-7.219-2.716-7.357-.177-.181-.198-.181-1.503-.203-1.122-.015-1.341 0-1.475.094Z" />
        <path d="M92.069 12.21c-.149.1-1.059 1.327-2.435 3.279-1.418 2.024-2.237 3.127-2.328 3.141a.394.394 0 0 1-.247-.072c-.064-.051-1.03-1.4-2.145-2.997-1.115-1.596-2.131-3.01-2.265-3.141l-.24-.232h-1.433c-1.305 0-1.446.014-1.552.13-.176.203-.148.508.085.806.423.558 5.595 8.017 5.666 8.176.056.116.05.218-.028.378-.057.116-1.49 2.104-3.19 4.418-3.034 4.15-3.076 4.208-3.076 4.542v.341h3.09l2.336-3.258c1.284-1.784 2.378-3.294 2.441-3.344.057-.051.177-.073.261-.044.113.03.861 1.038 2.35 3.178 1.369 1.952 2.286 3.2 2.427 3.301.233.16.297.167 1.8.167 1.644 0 1.735-.014 1.735-.32 0-.202.135 0-3.196-4.759-2.83-4.041-2.956-4.23-2.956-4.542 0-.312.112-.479 2.815-4.295 1.545-2.184 2.865-4.085 2.935-4.23.156-.319.07-.61-.197-.718-.106-.043-.685-.072-1.299-.072-1.044 0-1.129.007-1.354.166ZM110.372 12.115c-.395.167-.374-.392-.36 9.454l.021 9.033.169.188.17.19h5.652c3.111 0 5.687-.03 5.729-.059.191-.13.24-.406.24-1.393 0-.566-.035-1.088-.071-1.168-.19-.356-.211-.356-4.431-.356-3.718 0-3.951-.007-4.057-.13-.106-.124-.12-.806-.134-7.764l-.021-7.632-.198-.196-.19-.203-1.186-.015c-.649-.007-1.249.015-1.333.051Z" />
        <path d="M144.869 12.151c-.127.058-.458.334-.741.617-.973.994-2.265 1.712-3.718 2.068-.29.072-.649.188-.791.268-.409.204-.479.421-.479 1.437s.07 1.226.409 1.371c.388.167 1.644-.13 2.78-.66.593-.268.635-.283.797-.174a.57.57 0 0 1 .212.348c.021.13.035 2.481.021 5.217-.021 4.868-.021 4.984-.162 5.144-.275.319-.508.363-1.976.363-1.376 0-1.383 0-1.552.18-.169.168-.177.211-.177 1.198v1.03l.205.21.205.211h4.904c4.565 0 4.911-.007 5.052-.13.148-.117.155-.175.134-1.285-.014-.769-.08-1.185-.198-1.248-.12-.065-.578-.094-1.496-.094h-1.326l-.226-.21-.233-.21-.035-7.662-.035-7.662-.191-.196c-.169-.174-.261-.203-.67-.218-.318-.014-.558.015-.713.087ZM124.985 12.224c-.31.217-.317.304-.296 4.723l.021 4.216.198.26c.395.53.31.516 3.612.567 2.597.029 3.013.05 3.352.166 1.129.385 1.764.987 2.06 1.96.156.507.177 1.392.057 1.864-.388 1.466-1.771 2.46-3.436 2.46-1.525 0-2.773-.784-3.409-2.14-.395-.835-.402-.835-1.848-.835-1.447 0-1.468.022-1.468.631 0 .327.057.53.304 1.067.43.936.74 1.407 1.361 2.075 1.228 1.32 2.731 1.988 4.686 2.082 3.069.145 5.567-1.14 6.632-3.417.452-.958.593-1.64.586-2.8-.007-2.424-1.037-4.187-3.013-5.145-1.129-.544-2.166-.725-4.523-.776-1.009-.022-1.919-.073-2.025-.116-.353-.138-.409-.407-.409-1.901 0-1.495.049-1.734.36-1.96.148-.1.55-.115 3.767-.115 3.698 0 4.058-.03 4.199-.29.035-.073.07-.61.07-1.19 0-1.023-.007-1.052-.183-1.27l-.184-.225h-5.165c-4.41 0-5.186.014-5.306.109Z" />
        <path d="M97.523 12.369c-.466.21-.444-.312-.423 9.388l.02 8.78.149.203.148.203 5.13.021 5.13.015.098-.254c.127-.305.142-1.712.029-2.06-.156-.443-.134-.443-3.839-.443-2.18 0-3.408-.029-3.5-.073-.127-.072-.134-.181-.134-2.503 0-2.321 0-2.423.156-2.532.141-.101.564-.116 3.217-.116h3.055l.17-.181c.169-.167.176-.21.176-1.125 0-.522-.035-1.016-.07-1.095-.184-.341-.29-.356-3.458-.356-1.912 0-3.02-.029-3.112-.072-.127-.073-.134-.182-.134-2.504 0-2.321 0-2.423.156-2.532.141-.101.592-.116 3.492-.116 3.211 0 3.345-.007 3.472-.138.19-.196.233-.515.204-1.415-.021-.725-.028-.776-.218-.965l-.191-.203-4.748-.014c-3.994-.015-4.777 0-4.975.087ZM34.428 24.696c0 4.527-.007 4.767-.141 5.21-.17.573-.593 1.197-1.037 1.53-.664.486-13.57 8.112-13.816 8.155a1.154 1.154 0 0 1-1.002-.29c-.31-.283-.444-.595-.444-1.03 0-.182-.022-.327-.043-.327-.092 0-3.627 2.126-3.627 2.177 0 .029.53.37 1.186.755 1.369.805 1.806.95 2.625.892.289-.022.691-.102.882-.174.197-.08 3.76-2.162 7.93-4.63 5.399-3.199 7.692-4.6 7.96-4.846.473-.45.84-1.19.938-1.9.035-.29.07-2.446.07-4.978v-4.476l-.677-.407c-.373-.225-.705-.406-.74-.406-.036 0-.064 2.082-.064 4.745Z" />
        <path d="M20.562 31.857a4301.717 4301.717 0 0 1-12.715 7.524c-.211.101-.24.101-.367-.022-.127-.109-.148-.24-.162-.972l-.021-.842-1.164-.704c-.642-.391-1.207-.703-1.25-.71-.07 0-.091.355-.091 1.538 0 2.22.148 2.793.931 3.555.544.537 1.016.733 1.82.769.53.021.749 0 1.038-.11.198-.072 5.807-3.358 12.468-7.313l12.101-7.182.007-1.473c0-.805-.02-1.466-.056-1.466-.028 0-5.673 3.33-12.539 7.408Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h150v42H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function Photoroom() {
  return (
    <svg fill="none" width={110} viewBox="0 0 132 24">
      <g className="fill-foreground">
        <path
          fillRule="evenodd"
          d="M0 7.2c0-2.237 0-3.355.365-4.237A4.8 4.8 0 0 1 2.963.365C3.845 0 4.963 0 7.2 0h9.6c2.236 0 3.355 0 4.237.365a4.8 4.8 0 0 1 2.598 2.598C24 3.845 24 4.963 24 7.2v9.6c0 2.236 0 3.355-.365 4.237a4.8 4.8 0 0 1-2.598 2.598c-.882.365-2 .365-4.237.365H7.2c-2.237 0-3.355 0-4.237-.365a4.8 4.8 0 0 1-2.598-2.598C0 20.155 0 19.037 0 16.8zm7.032 1.212a1.656 1.656 0 1 1 0-3.312h7.452a4.692 4.692 0 1 1 0 9.384H8.688v2.76a1.656 1.656 0 1 1-3.312 0v-4.416c0-.915.741-1.656 1.656-1.656h7.452a1.38 1.38 0 1 0 0-2.76zm7.452 7.452h-.686l2.551 2.551a1.656 1.656 0 1 0 2.342-2.342l-1.077-1.077a6.044 6.044 0 0 1-3.13.868zM30.6 18.997h3.042v-4.462h2.84c2.94 0 4.969-2.028 4.969-4.867 0-2.84-2.029-4.868-4.97-4.868H30.6zm3.042-7.2V7.538h2.535c1.42 0 2.231.811 2.231 2.13 0 1.318-.81 2.13-2.23 2.13z"
          clipRule="evenodd"
        />
        <path d="M45.593 18.997h-2.84V4.8h2.84v4.563h.102c.71-.81 1.52-1.318 2.738-1.318 2.332 0 3.955 1.623 3.955 4.36v6.592h-2.84v-6.186c0-1.42-.71-2.23-1.926-2.23s-2.029.912-2.029 2.23zM70.031 18.997h2.028V16.36h-1.52c-.61 0-1.015-.405-1.015-1.014v-4.462h2.535V8.248h-2.535v-2.84H67.09l-.405 2.84H64.96v2.636h1.724v4.97c0 2.028 1.115 3.143 3.346 3.143z" />
        <g fillRule="evenodd" clipRule="evenodd">
          <path d="M73.084 13.623c0 3.549 2.028 5.577 5.273 5.577 3.245 0 5.273-2.028 5.273-5.577s-2.028-5.578-5.273-5.578c-3.245 0-5.273 2.028-5.273 5.577zm7.707 0c0 2.13-1.116 3.042-2.434 3.042s-2.434-.913-2.434-3.042c0-2.13 1.116-3.043 2.434-3.043s2.434.913 2.434 3.042zM97.723 19.2c-3.245 0-5.273-2.028-5.273-5.577s2.028-5.578 5.273-5.578c3.245 0 5.273 2.028 5.273 5.577s-2.028 5.578-5.273 5.578zm0-2.535c1.318 0 2.434-.913 2.434-3.042 0-2.13-1.116-3.043-2.434-3.043s-2.434.913-2.434 3.042c0 2.13 1.116 3.043 2.434 3.043zM109.483 19.2c-3.245 0-5.273-2.028-5.273-5.577s2.028-5.578 5.273-5.578 5.273 2.028 5.273 5.577-2.028 5.578-5.273 5.578zm0-2.535c1.318 0 2.434-.913 2.434-3.042 0-2.13-1.116-3.043-2.434-3.043s-2.434.913-2.434 3.042c0 2.13 1.116 3.043 2.434 3.043z" />
        </g>
        <path d="M116.274 18.997h2.84V12.71c0-1.42.811-2.13 1.724-2.13 1.014 0 1.825.609 1.825 2.13v6.287h2.839V12.71c0-1.42.812-2.13 1.724-2.13 1.014 0 1.826.609 1.826 2.13v6.287h2.839v-6.693c0-2.636-1.622-4.259-3.955-4.259-1.379 0-2.738.73-3.245 1.724h-.101c-.528-1.055-1.663-1.724-2.941-1.724-1.116 0-1.927.507-2.535 1.42h-.102l-.304-1.217h-2.434zM87.988 18.997h-2.84V8.247h2.434l.304 1.218h.102c.608-.913 1.52-1.217 2.535-1.217h1.318v2.738h-1.115c-1.724 0-2.738 1.014-2.738 2.637z" />
        <path
          fillRule="evenodd"
          d="M59.075 19.2c-3.245 0-5.273-2.028-5.273-5.577s2.028-5.578 5.273-5.578c3.245 0 5.273 2.028 5.273 5.577S62.32 19.2 59.075 19.2zm0-2.535c1.318 0 2.434-.913 2.434-3.042 0-2.13-1.116-3.043-2.434-3.043s-2.434.913-2.434 3.042c0 2.13 1.116 3.043 2.434 3.043z"
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
}

export function CalPoly() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={40}
      viewBox="0 0 246 340"
      className="fill-foreground"
    >
      <g transform="matrix(1.3333 0 0 -1.3333 -502.53 560.54)">
        <g>
          <path
            d="m556.35 369.83c-6.539 8.4806-18.116 9.4609-26.254 9.4609 0 0-13.963 3e-3 -29.248 3e-3 1.1082 4.7135 2.8602 12.181 3.2497 14.157 1.239 6.2833-0.1558 12.268-3.9346 16.866-5.0707 6.1745-13.554 9.1772-25.925 9.1772-0.0191 0-40.253 0.0323-40.253 0.0323-21.492 0-33.772-9.1875-39.819-29.788l-0.0382-0.13081c-0.0265-0.0911-0.0456-0.17196-15.043-58.156-2.7323-10.193-1.8166-18.134 2.8249-24.181 6.4067-8.3527 17.345-9.3183 25.017-9.3183l29.601-0.0294c-4.0066-12.932-9.1993-29.678-9.627-31.062-1.2096-1.796-17.598-26.084-17.598-26.084l70.73-0.025s6.9285 22.31 9.3257 30.024c6.6963-0.0176 16.87-0.047 16.87-0.047 22.534 0 34.254 8.6408 40.476 29.827l0.0544 0.1896 12.12 45.009c1.2317 4.6768 4.0757 15.51-2.528 24.075"
            fill="#000000"
          />
          <path
            d="m433.98 410.95c-17.74 0-26.592-6.6271-31.585-23.628v-0.00146c-0.0279-0.10141-15.009-58.02-15.009-58.02-2.0404-7.6276-1.6153-12.972 1.3286-16.812 3.1659-4.1242 8.7824-5.9634 18.212-5.9634l40.556-0.03515c17.869 0 27.325 6.4402 31.762 21.532l4.0796 13.825-43.544-0.00293-0.42627-2.7363c-0.0118-0.0735-1.1967-7.3843-6.0352-7.3843-1.167 0-1.5249 0.24022-1.5293 0.24316-0.0985 0.24839-0.02158 1.1625 0.28125 2.6484 0.37626 1.8372 6.2618 25.516 11.188 45.239l0.08642 0.35156c1.1479 4.7914 4.3224 5.9326 6.1714 5.5093 0.5056-0.11611 0.78333-0.40084 0.89062-0.55664-0.29689-1.2934-2.3569-10.26-2.3569-10.26l4.0342-0.01758 38.897-0.03222 0.58887 2.477c0.14551 0.61583 3.5915 15.136 4.1162 17.785 0.74224 3.77 0.00433 7.1426-2.1445 9.7588-3.3437 4.0698-9.6591 6.0469-19.305 6.0469-0.0176 0-40.258 0.03369-40.258 0.03369zm23.372-40.226 1.5982-4.3316s2.4956-6.7652 3.0835-8.3599c-0.41152-1.3963-3.6284-12.302-3.6284-12.302h45.447c3.013 0 3.5844-0.5493 3.5889-0.55371 0.0764-0.12346 0.13037-0.35028 0.13037-0.73242 0-0.95828-0.34178-2.9094-1.5117-6.7749 0 0-8.0551-27.709-8.0771-27.785-0.0941-0.24104-0.41895-1.0752-0.41895-1.0752-1.5183-3.9375-1.6781-4.3491-5.3686-4.3491h-44.662s-12.543-40.465-12.816-41.351c-0.48503-0.72018-9.2871-13.765-9.2871-13.765l48.294-0.01465s8.12 26.158 9.3267 30.038c3.9081-0.0103 23.205-0.06445 23.205-0.06445 18.659 0 27.093 6.192 32.225 23.666 0.0176 0.0691 12.125 45.013 12.125 45.013 1.555 5.9232 2.4977 12.017-1.043 16.607-3.2203 4.1786-9.4058 6.123-19.463 6.123l-68.131 0.01172h-4.6157z"
            fill="#666666"
          />
          <path
            d="m433.98 407.73c-16.422 0-23.879-5.584-28.499-21.318 0 0-14.978-57.904-14.981-57.921-3.7979-14.17 1.829-18.75 16.43-18.75l40.553-0.03662c16.403 0 24.679 5.5661 28.677 19.223l2.8623 9.7017-36.488-0.00293s-1.4829-10.118-9.2139-10.118c-5.6468 0-4.9457 4.0765-4.3989 6.7515 0.54822 2.6735 11.282 45.613 11.282 45.62 1.6212 6.7653 6.6067 8.7507 10.033 7.9673 2.1929-0.50266 3.7218-2.4189 3.394-4.0254-0.24986-1.217-1.5425-6.7251-1.5425-6.7251l36.356-0.0293s3.5725 15.045 4.0898 17.665c1.4066 7.1372-3.7584 11.966-18.293 11.966l-40.261 0.03223zm27.99-40.225 3.4438-9.3618-0.04981-0.17138-2.6558-9.022h41.145c8.0573 0 7.9366-3.4467 5.2852-12.215-2.3634-7.8147-8.101-27.879-8.105-27.883-1.9768-4.984-2.3998-7.6099-8.8359-7.6099h-42.293l-12.256-39.539-6.1685-9.148 39.895-0.01025 9.3091 30.042s25.571-0.06885 25.575-0.06885c17.365 0 24.456 5.4237 29.137 21.359 0 0 12.099 44.93 12.103 44.941 2.8161 10.713 2.56 18.677-17.399 18.677-0.00735 0-68.128 0.01025-68.128 0.01025z"
            fill="#cccccc"
          />
        </g>
      </g>

      <text
        x="123"
        y="295"
        fontFamily="Arial, sans-serif"
        fontWeight="bold"
        fontSize="54"
        textAnchor="middle"
        className="fill-foreground"
      >
        CalPoly
      </text>
    </svg>
  );
}

export function Windows(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={800}
      height={800}
      viewBox="0 0 256 256"
      {...props}
      className={cn(`fill-foreground`, props.className)}
    >
      <path d="M112 144v51.637a7.998 7.998 0 0 1-9.431 7.87l-64-11.636A8 8 0 0 1 32 184v-40a8 8 0 0 1 8-8h64a8 8 0 0 1 8 8Zm-2.874-89.778a7.995 7.995 0 0 0-6.557-1.73l-64 11.637A8 8 0 0 0 32 72v40a8 8 0 0 0 8 8h64a8 8 0 0 0 8-8V60.363a7.999 7.999 0 0 0-2.874-6.141Zm112-20.364a7.997 7.997 0 0 0-6.557-1.73l-80 14.547a8 8 0 0 0-6.569 7.87V112a8 8 0 0 0 8 8h80a8 8 0 0 0 8-8V40a8 8 0 0 0-2.874-6.142ZM216 136h-80a8 8 0 0 0-8 8v57.455a8 8 0 0 0 6.569 7.87l80 14.546A8 8 0 0 0 224 216v-72a8 8 0 0 0-8-8Z" />
    </svg>
  );
}

export function Linux(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 266 312"
      {...props}
      className={cn(`fill-foreground`, props.className)}
    >
      <path d="M128.664 79.28c0 1-1 1-1 1h-1c-1 0-1-1-2-2 0 0-1-1-1-2s0-1 1-1l2 1c1 1 2 2 2 3m-18-10c0-5-2-8-5-8 0 0 0 1-1 1v2h3c0 2 1 3 1 5h2m35-5c2 0 3 2 4 5h2c-1-1-1-2-1-3s0-2-1-3-2-2-3-2c0 0-1 1-2 1 0 1 1 1 1 2m-30 16c-1 0-1 0-1-1s0-2 1-3c2 0 3-1 3-1 1 0 1 1 1 1 0 1-1 2-3 4h-1m-11-1c-4-2-5-5-5-10 0-3 0-5 2-7 1-2 3-3 5-3s3 1 5 3c1 3 2 6 2 9v2h1v-1c1 0 1-2 1-6 0-3 0-6-2-9s-4-5-8-5c-3 0-6 2-7 5-2 4-2.4 7-2.4 12 0 4 1.4 8 5.4 12 1-1 2-1 3-2m125 141c1 0 1-.4 1-1.3 0-2.2-1-4.8-4-7.7-3-3-8-4.9-14-5.7-1-.1-2-.1-2-.1-1-.2-1-.2-2-.2-1-.1-3-.3-4-.5 3-9.3 4-17.5 4-24.7 0-10-2-17-6-23s-8-9-13-10c-1 1-1 1-1 2 5 2 10 6 13 12 3 7 4 13 4 20 0 5.6-1 13.9-5 24.5-4 1.6-8 5.3-11 11.1 0 .9 0 1.4 1 1.4 0 0 1-.9 2-2.6 2-1.7 3-3.4 5-5.1 3-1.7 5-2.6 8-2.6 5 0 10 .7 13 2.1 4 1.3 6 2.7 7 4.3 1 1.5 2 2.9 3 4.2 0 1.3 1 1.9 1 1.9m-92-145c-1-1-1-3-1-5 0-4 0-6 2-9 2-2 4-3 6-3 3 0 5 2 7 4 1 3 2 5 2 8 0 5-2 8-6 9 0 0 1 1 2 1 2 0 3 1 5 2 1-6 2-10 2-15 0-6-1-10-3-13-3-3-6-4-10-4-3 0-6 1-9 3-2 3-3 5-3 8 0 5 1 9 3 13 1 0 2 1 3 1m12 16c-13 9-23 13-31 13-7 0-14-3-20-8 1 2 2 4 3 5l6 6c4 4 9 6 14 6 7 0 15-4 25-11l9-6c2-2 4-4 4-7 0-1 0-2-1-2-1-2-6-5-16-8-9-4-16-6-20-6-3 0-8 2-15 6-6 4-10 8-10 12 0 0 1 1 2 3 6 5 12 8 18 8 8 0 18-4 31-14v2c1 0 1 1 1 1m23 202c4 7.52 11 11.3 19 11.3 2 0 4-.3 6-.9 2-.4 4-1.1 5-1.9 1-.7 2-1.4 3-2.2 2-.7 2-1.2 3-1.7l17-14.7c4-3.19 8-5.98 13-8.4 4-2.4 8-4 10-4.9 3-.8 5-2 7-3.6 1-1.5 2-3.4 2-5.8 0-2.9-2-5.1-4-6.7s-4-2.7-6-3.4-4-2.3-7-5c-2-2.6-4-6.2-5-10.9l-1-5.8c-1-2.7-1-4.7-2-5.8 0-.3 0-.4-1-.4s-3 .9-4 2.6c-2 1.7-4 3.6-6 5.6-1 2-4 3.8-6 5.5-3 1.7-6 2.6-8 2.6-8 0-12-2.2-15-6.5-2-3.2-3-6.9-4-11.1-2-1.7-3-2.6-5-2.6-5 0-7 5.2-7 15.7v31.1c0 .9-1 2.9-1 6-1 3.1-1 6.62-1 10.6l-2 11.1v.17m-145-5.29c9.3 1.36 20 4.27 32.1 8.71 12.1 4.4 19.5 6.7 22.2 6.7 7 0 12.8-3.1 17.6-9.09 1-1.94 1-4.22 1-6.84 0-9.45-5.7-21.4-17.1-35.9l-6.8-9.1c-1.4-1.9-3.1-4.8-5.3-8.7-2.1-3.9-4-6.9-5.5-9-1.3-2.3-3.4-4.6-6.1-6.9-2.6-2.3-5.6-3.8-8.9-4.6-4.2.8-7.1 2.2-8.5 4.1s-2.2 4-2.4 6.2c-.3 2.1-.9 3.5-1.9 4.2-1 .6-2.7 1.1-5 1.6-.5 0-1.4 0-2.7.1h-2.7c-5.3 0-8.9.6-10.8 1.6-2.5 2.9-3.8 6.2-3.8 9.7 0 1.6.4 4.3 1.2 8.1.8 3.7 1.2 6.7 1.2 8.8 0 4.1-1.2 8.2-3.7 12.3-2.5 4.3-3.8 7.5-3.8 9.78 1 3.88 7.6 6.61 19.7 8.21m33.3-90.9c0-6.9 1.8-14.5 5.5-23.5 3.6-9 7.2-15 10.7-19-.2-1-.7-1-1.5-1l-1-1c-2.9 3-6.4 10-10.6 20-4.2 9-6.4 17.3-6.4 23.4 0 4.5 1.1 8.4 3.1 11.8 2.2 3.3 7.5 8.1 15.9 14.2l10.6 6.9c11.3 9.8 17.3 16.6 17.3 20.6 0 2.1-1 4.2-4 6.5-2 2.4-4.7 3.6-7 3.6-.2 0-.3.2-.3.7 0 .1 1 2.1 3.1 6 4.2 5.7 13.2 8.5 25.2 8.5 22 0 39-9 52-27 0-5 0-8.1-1-9.4v-3.7c0-6.5 1-11.4 3-14.6s4-4.7 7-4.7c2 0 4 .7 6 2.2 1-7.7 1-14.4 1-20.4 0-9.1 0-16.6-2-23.6-1-6-3-11-5-15l-6-9c-2-3-3-6-5-9-1-4-2-7-2-12-3-5-5-10-8-15-2-5-4-10-6-14l-9 7c-10 7-18 10-25 10-6 0-11-1-14-5l-6-5c0 3-1 7-3 11l-6.3 12c-2.8 7-4.3 11-4.6 14-.4 2-.7 4-.9 4l-7.5 15c-8.1 15-12.2 28.9-12.2 40.4 0 2.3.2 4.7.6 7.1-4.5-3.1-6.7-7.4-6.7-13m71.6 94.6c-13 0-23 1.76-30 5.25v-.3c-5 6-10.6 9.1-18.4 9.1-4.9 0-12.6-1.9-23-5.7-10.5-3.6-19.8-6.36-27.9-8.18-.8-.23-2.6-.57-5.5-1.03-2.8-.45-5.4-.91-7.7-1.37-2.1-.45-4.5-1.13-7.1-2.05-2.5-.79-4.5-1.82-6-3.07-1.38-1.26-2.06-2.68-2.06-4.27 0-1.6.34-3.31 1.02-5.13.64-1.1 1.34-2.2 2.04-3.2.7-1.1 1.3-2.1 1.7-3.1.6-.9 1-1.8 1.4-2.8.4-.9.8-1.8 1-2.9.2-1 .4-2 .4-3s-.4-4-1.2-9.3c-.8-5.2-1.2-8.5-1.2-9.9 0-4.4 1-7.9 3.2-10.4s4.3-3.8 6.5-3.8h11.5c.9 0 2.3-.5 4.4-1.7.7-1.6 1.3-2.9 1.7-4.1.5-1.2.7-2.1.9-2.5.2-.6.4-1.2.6-1.7.4-.7.9-1.5 1.6-2.3-.8-1-1.2-2.3-1.2-3.9 0-1.1 0-2.1.2-2.7 0-3.6 1.7-8.7 5.3-15.4l3.5-6.3c2.9-5.4 5.1-9.4 6.7-13.4 1.7-4 3.5-10 5.5-18 1.6-7 5.4-14 11.4-21l7.5-9c5.2-6 8.6-11 10.5-15s2.9-9 2.9-13c0-2-.5-8-1.6-18-1-10-1.5-20-1.5-29 0-7 .6-12 1.9-17s3.6-10 7-14c3-4 7-8 13-10s13-3 21-3c3 0 6 0 9 1 3 0 7 1 12 3 4 2 8 4 11 7 4 3 7 8 10 13 2 6 4 12 5 20 1 5 1 10 2 17 0 6 1 10 1 13 1 3 1 7 2 12 1 4 2 8 4 11 2 4 4 8 7 12 3 5 7 10 11 16 9 10 16 21 20 32 5 10 8 23 8 36.9 0 6.9-1 13.6-3 20.1 2 0 3 .8 4 2.2s2 4.4 3 9.1l1 7.4c1 2.2 2 4.3 5 6.1 2 1.8 4 3.3 7 4.5 2 1 5 2.4 7 4.2 2 2 3 4.1 3 6.3 0 3.4-1 5.9-3 7.7-2 2-4 3.4-7 4.3-2 1-6 3-12 5.82-5 2.96-10 6.55-15 10.8l-10 8.51c-4 3.9-8 6.7-11 8.4-3 1.8-7 2.7-11 2.7l-7-.8c-8-2.1-13-6.1-16-12.2-16-1.94-29-2.9-37-2.9" />
    </svg>
  );
}

export function Apple(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={800}
      height={800}
      viewBox="0 0 24 24"
      {...props}
      className={cn(`fill-foreground`, props.className)}
    >
      <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83ZM13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11Z" />
    </svg>
  );
}

export function X(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={300}
      height={300.251}
      viewBox="0 0 300 300.251"
      className={cn(`fill-foreground`, props.className)}
    >
      <path d="M178.57 127.15 290.27 0h-26.46l-97.03 110.38L89.34 0H0l117.13 166.93L0 300.25h26.46l102.4-116.59 81.8 116.59H300M36.01 19.54h40.65l187.13 262.13h-40.66" />
    </svg>
  );
}

export const LinkedIn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    className={cn(`fill-foreground`, props.className)}
  >
    <path d="M19 0H5a5 5 0 0 0-5 5v14a5 5 0 0 0 5 5h14a5 5 0 0 0 5-5V5a5 5 0 0 0-5-5zM8 19H5V8h3v11zM6.5 6.732c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zM20 19h-3v-5.604c0-3.368-4-3.113-4 0V19h-3V8h3v1.765c1.396-2.586 7-2.777 7 2.476V19z" />
  </svg>
);

export const Discord = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid"
    viewBox="0 -28.5 256 256"
    className={cn(`fill-foreground`, props.className)}
  >
    <path d="M216.856 16.597A208.502 208.502 0 0 0 164.042 0c-2.275 4.113-4.933 9.645-6.766 14.046-19.692-2.961-39.203-2.961-58.533 0-1.832-4.4-4.55-9.933-6.846-14.046a207.809 207.809 0 0 0-52.855 16.638C5.618 67.147-3.443 116.4 1.087 164.956c22.169 16.555 43.653 26.612 64.775 33.193A161.094 161.094 0 0 0 79.735 175.3a136.413 136.413 0 0 1-21.846-10.632 108.636 108.636 0 0 0 5.356-4.237c42.122 19.702 87.89 19.702 129.51 0a131.66 131.66 0 0 0 5.355 4.237 136.07 136.07 0 0 1-21.886 10.653c4.006 8.02 8.638 15.67 13.873 22.848 21.142-6.58 42.646-16.637 64.815-33.213 5.316-56.288-9.08-105.09-38.056-148.36ZM85.474 135.095c-12.645 0-23.015-11.805-23.015-26.18s10.149-26.2 23.015-26.2c12.867 0 23.236 11.804 23.015 26.2.02 14.375-10.148 26.18-23.015 26.18Zm85.051 0c-12.645 0-23.014-11.805-23.014-26.18s10.148-26.2 23.014-26.2c12.867 0 23.236 11.804 23.015 26.2 0 14.375-10.148 26.18-23.015 26.18Z" />
  </svg>
);

export const LightCircles = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1984"
    height="1984"
    viewBox="0 0 1984 1984"
    fill="none"
    className={props.className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="1983"
      height="1983"
      rx="991.5"
      fill="#FCFCFC"
    />
    <rect
      x="0.5"
      y="0.5"
      width="1983"
      height="1983"
      rx="991.5"
      stroke="#F3F3F3"
    />
    <rect
      x="100.5"
      y="100.5"
      width="1783"
      height="1783"
      rx="891.5"
      fill="#FCFCFC"
    />
    <rect
      x="100.5"
      y="100.5"
      width="1783"
      height="1783"
      rx="891.5"
      stroke="#F3F3F3"
    />
    <rect
      x="200.5"
      y="200.5"
      width="1583"
      height="1583"
      rx="791.5"
      fill="#FCFCFC"
    />
    <rect
      x="200.5"
      y="200.5"
      width="1583"
      height="1583"
      rx="791.5"
      stroke="#F3F3F3"
    />
    <rect
      x="300.5"
      y="300.5"
      width="1383"
      height="1383"
      rx="691.5"
      fill="#FCFCFC"
    />
    <rect
      x="300.5"
      y="300.5"
      width="1383"
      height="1383"
      rx="691.5"
      stroke="#F3F3F3"
    />
    <rect
      x="400.25"
      y="400.25"
      width="1183.5"
      height="1183.5"
      rx="591.75"
      fill="#FCFCFC"
    />
    <rect
      x="400.25"
      y="400.25"
      width="1183.5"
      height="1183.5"
      rx="591.75"
      stroke="#F3F3F3"
      strokeWidth="0.5"
    />
    <rect
      x="500.25"
      y="500.25"
      width="983.5"
      height="983.5"
      rx="491.75"
      fill="#FCFCFC"
    />
    <rect
      x="500.25"
      y="500.25"
      width="983.5"
      height="983.5"
      rx="491.75"
      stroke="#F3F3F3"
      strokeWidth="0.5"
    />
    <rect
      x="600.25"
      y="600.25"
      width="783.5"
      height="783.5"
      rx="391.75"
      fill="#F8F8F8"
    />
    <rect
      x="600.25"
      y="600.25"
      width="783.5"
      height="783.5"
      rx="391.75"
      stroke="#F3F3F3"
      strokeWidth="0.5"
    />
    <rect
      x="700.25"
      y="700.25"
      width="583.5"
      height="583.5"
      rx="291.75"
      fill="#FCFCFC"
    />
    <rect
      x="700.25"
      y="700.25"
      width="583.5"
      height="583.5"
      rx="291.75"
      stroke="#F3F3F3"
      strokeWidth="0.5"
    />
  </svg>
);

export const DarkCircles = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1984"
    height="1984"
    viewBox="0 0 1984 1984"
    fill="none"
    className={props.className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="1983"
      height="1983"
      rx="991.5"
      fill="#101010"
    />
    <rect
      x="0.5"
      y="0.5"
      width="1983"
      height="1983"
      rx="991.5"
      stroke="#202020"
    />
    <rect
      x="100.5"
      y="100.5"
      width="1783"
      height="1783"
      rx="891.5"
      fill="#101010"
    />
    <rect
      x="100.5"
      y="100.5"
      width="1783"
      height="1783"
      rx="891.5"
      stroke="#202020"
    />
    <rect
      x="200.5"
      y="200.5"
      width="1583"
      height="1583"
      rx="791.5"
      fill="#101010"
    />
    <rect
      x="200.5"
      y="200.5"
      width="1583"
      height="1583"
      rx="791.5"
      stroke="#202020"
    />
    <rect
      x="300.5"
      y="300.5"
      width="1383"
      height="1383"
      rx="691.5"
      fill="#101010"
    />
    <rect
      x="300.5"
      y="300.5"
      width="1383"
      height="1383"
      rx="691.5"
      stroke="#202020"
    />
    <rect
      x="400.25"
      y="400.25"
      width="1183.5"
      height="1183.5"
      rx="591.75"
      fill="#101010"
    />
    <rect
      x="400.25"
      y="400.25"
      width="1183.5"
      height="1183.5"
      rx="591.75"
      stroke="#202020"
      strokeWidth="0.5"
    />
    <rect
      x="500.25"
      y="500.25"
      width="983.5"
      height="983.5"
      rx="491.75"
      fill="#101010"
    />
    <rect
      x="500.25"
      y="500.25"
      width="983.5"
      height="983.5"
      rx="491.75"
      stroke="#202020"
      strokeWidth="0.5"
    />
    <rect
      x="600.25"
      y="600.25"
      width="783.5"
      height="783.5"
      rx="391.75"
      fill="#151515"
    />
    <rect
      x="600.25"
      y="600.25"
      width="783.5"
      height="783.5"
      rx="391.75"
      stroke="#202020"
      strokeWidth="0.5"
    />
    <rect
      x="700.25"
      y="700.25"
      width="583.5"
      height="583.5"
      rx="291.75"
      fill="#101010"
    />
    <rect
      x="700.25"
      y="700.25"
      width="583.5"
      height="583.5"
      rx="291.75"
      stroke="#202020"
      strokeWidth="0.5"
    />
  </svg>
);
